import { Component, OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter, ViewChild } from '@angular/core';
import { TinyMceModule, TinyMceComponent } from 'angular-tinymce';
import { tinymceDefaultSettings } from 'angular-tinymce';

import * as TinyMce from 'tinymce';
import { ROUTER_CONFIGURATION } from '@angular/router';

@Component({
  selector: 'sn-tinymce',
  templateUrl: './tinymce.component.html',
  styleUrls: ['./tinymce.component.css']
})
export class TinymceComponent implements OnInit, OnChanges {
// @Input() public content:any;
@Input() public settings:any;
@ViewChild('mce') mce:TinyMceComponent;
@Output() public contentChange = new EventEmitter();

  @Input() get content() {
    return this.currentContent;
  }

  set content(value) {
    this.currentContent = value;
    this.contentChange.emit(this.currentContent);
  }

  currentContent:any = '';
  public customSettings: TinyMce.Settings | any;

  constructor() { }

  ngOnInit() {
    console.log(this.content);
    this.currentContent = this.content;
    this.customSettings = Object.assign(tinymceDefaultSettings(), this.settings);
    if (this.settings.readonly == true) {
      this.mce.disabled = true;
    }
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    //console.log("new change: " + this.content);
    this.currentContent = this.content;
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/editors/tinymce/tinymce.component.ts